import { render, staticRenderFns } from "./emotion.vue?vue&type=template&id=1f2ba715&scoped=true"
import script from "./emotion.vue?vue&type=script&lang=js"
export * from "./emotion.vue?vue&type=script&lang=js"
import style0 from "./emotion.vue?vue&type=style&index=0&id=1f2ba715&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2ba715",
  null
  
)

export default component.exports